import { LiveDelay, livePoll, videoTag } from '../../helpers/constants'
import {
  addUuidToSrc,
  appendQueryParamsToChunks,
  compare,
  handleRipple,
  responseValidator,
  handlePageTitle, handleHasXTokenParamOrSendXToken, weighted_random, getUUID,
} from '../../helpers/helpers'
import { apiCaller, getAll } from '../../services/apiCaller'
import { API, getApiUrls } from '../../services/services'
import { setIsLive } from '../slices/controllerSlice'
import {
  setAlternative_Lives,
  setChartPoints,
  setConfig, setEmojiList1, setEmojiList2,
  setEmojis, setErrorType, setGif,
  setInfo,
  setIsFetchDetails,
  setIsLiveError,
  setIsValidAddress,
  setLiveId,
  setMarkers,
  setOnlineViewers, setQuestion, setSelectedOptionId, setSelectedSubtitle, setSubtitleText,
} from '../slices/videoDataSlice'
import { detailErrorLog, playListClickLog, recommendationListLog, subtitleLog, videoOfPlaylistClickLog } from '../../logs/logs'
import { RetryCountGeneralDataFetch, RetryTimeDelayGeneralDataFetch } from '../../helpers/environment'
import store from '../store'
import {conditions} from "../../helpers/conditions/conditions";
import {ConditionName, ContentTypesString} from "../../interfaces/enums";
import {IDetails, IMarker} from "../../interfaces/interfaces";
import {handleVideoTimeline} from "./controller.actions";
import { setChatEnabled, setChatType, setMessages, setRoomId } from '../slices/chatSlice'
import { sendFluentLog } from "../../logs/fluentdLogger";
import Cookies from "js-cookie";
import { handleSendVoucher } from "./user.actions";
import { setShowVoucherPopup } from "../slices/userSlice";
import { setQuiz } from "../slices/quizSlice";
import { handleDetailsConfig } from '../../configs/getDetailsConfigs'
import { setChatPopover, setPlayListPopover } from '../slices/popoversSlice'
import { MouseEventHandler } from 'react'

const videoViewCount = (contentId: number) => apiCaller({ url: API().viewCount(contentId), data: {"uuid": getUUID()} });

const handleDetailsInLive = (details:IDetails) => {
  const dispatch = store.dispatch;
  dispatch(setLiveId(details.id!));
  dispatch(setIsLive(true));
  dispatch(setIsLiveError(false));
  if (!conditions(ConditionName.isEnded)) detailSetter(details)
  else setTimeout(() => detailSetter(details), LiveDelay * 1000)
}

export const getLiveAndVodDetails = async (userId?:number) => {  
  try {
    const { data: details, status } = await apiCaller(handleDetailsConfig(userId));
    if(responseValidator(status)) {
      if (!conditions(ConditionName.hasVoucherToken) && !conditions(ConditionName.isCinemaHamrahEnvironment)) {
        appendQueryParamsToChunks(details.stream_link);
        await apiCaller({ url: "https://" + weighted_random(details.hls_links) + details.path, method: "head" });
      }
      if (userId) return details;
      videoViewCount(details.content_id!);
      if (conditions(ConditionName.isLiveParam)) handleDetailsInLive(details);
      else detailSetter(details);
    } else throw new Error(status)
  } catch (error:any) {
    if(userId) return;
    const dispatch = store.dispatch;
    const { params } = store.getState().videoData;
    if (error.message !== "404") sendFluentLog(detailErrorLog(error));
    handlePageTitle(String(params.id));
    dispatch(setIsFetchDetails(true));
    dispatch(setErrorType('liveAndVod'));
    if (conditions(ConditionName.isLiveParam)) dispatch(setIsLiveError(true));
    if (conditions(ConditionName.hasVoucherToken)) {
      Cookies.remove('voucher-token')
      if (conditions(ConditionName.hasVoucherCodeParams)) handleSendVoucher(params.voucherCode!)
      else dispatch(setShowVoucherPopup(true))
    } else dispatch(setIsValidAddress(false))
  }
}

export const detailSetter = (data: any) => {
  const dispatch = store.dispatch
  const { params } = store.getState().videoData

  if (data.title) handlePageTitle(data.title)
  else handlePageTitle(String(params.id))
  dispatch(setInfo({
    ...data,
    stream_link: !!data.stream_link && addUuidToSrc('https://' + weighted_random(data.hls_links) + data.path),
  }))
  dispatch(setIsFetchDetails(true))
  dispatch(setIsValidAddress(true))
}

export const getMarkers = async (id: Number) => await getAll(getApiUrls().apiMarkerUrl + id + '/', [
    {
      codeAbove: 400,
      codeBelow: null,
      excludeCodes: [],
      includeCodes: [],
      delay: 2,
      count: 3
    }
  ])

export const getPersonalMarkers = async () => apiCaller({
  url: API().user.getPersonalMarker,
  headers: handleHasXTokenParamOrSendXToken(),
})

const manualGeneralErrorResponseHandler = (retryCount: any, dispatch: any, setRetryCount: any, intervalIds: any, setIntervalIds: any, errorDetail: any, requestType: string) => {
  if (requestType === 'getData' && retryCount !== RetryCountGeneralDataFetch && retryCount !== 1) {
    // dispatch(setConfig({
    //     ...config,
    //     empoji_poll_interval: RetryTimeDelayGeneralDataFetch
    // }));
    setRetryCount(retryCount - 1)
  } else if (retryCount === 1 && intervalIds.length > 0) {
    intervalIds.forEach((id: any) => clearInterval(id))
    setIntervalIds([])
  }
  console.error(`get aggregat error: ${errorDetail.detail}`)
}

export const firstGetDataIntervalAPI = async (retryCount: any, setRetryCount: any, dispatch: any, setIntervalTime: any, setOnlineViewerIntervalTime: any, setPostDataIntervalTime: any) => {
  const { params } = store.getState().videoData
  const { roomId, chatEnabled, socket, showChat } = store.getState().chats
  const { data, status } = await apiCaller({ url: API().live.generalData })
  if (responseValidator(status) && data.config) {
    if (!!data.backup) window.location.href = (window.location.href.replace(`id=${params.id}`, `id=${data.backup}`).replace(`&t=${params.t}`, ``))
    setRetryCount(RetryCountGeneralDataFetch)
    dispatch(setConfig(data.config))
    setIntervalTime(data.config.get_interval)
    setOnlineViewerIntervalTime(data.config.viewers_interval)
    setPostDataIntervalTime(data.config.empoji_poll_interval)
    dispatch(setEmojis(data.emojis))
    dispatch(setOnlineViewers(data.online_viewers))
    dispatch(setQuestion(data.question))
    dispatch(setAlternative_Lives(data.alternative_lives))
    dispatch(setMarkers(data.markers.sort(compare)))
    dispatch(setGif(data.gif))
    let roomIdTemp: number | undefined = undefined
    if (data.chat_enabled) {
      let { data: _data, status: _status } = await apiCaller({ url: API().live.liveChat.getRoomId(+String(params.id)) })
      if (responseValidator(_status)) {
        if (roomId !== _data.id && socket) {
          dispatch(setMessages([]));
          dispatch(setChatEnabled(false));
        }
        dispatch(setRoomId(_data.id));
        dispatch(setChatType(_data.type));
        roomIdTemp = _data.id;
      }
    } else if (chatEnabled && socket) {
      dispatch(setMessages([]));
      dispatch(setChatEnabled(false));
    }
    
    if (chatEnabled !== !!roomIdTemp) {
      setTimeout(()=>{
        if (showChat) dispatch(setChatPopover(true));
        dispatch(setChatEnabled(!!roomIdTemp));
      }, 0)  
    }
    
    dispatch(setQuiz(data.quiz))
    if (data.timeline.windows.length) {
      const points: number[] = []
      data.timeline.windows.map((window: { window_number: number, viewers: number }) => points.push(window.viewers))
      dispatch(setChartPoints(points))
    }
    if (!data && !data.question && !data.question.active) {
      // state 1
      if ((!!livePoll() && livePoll().liveId !== params.id) || !livePoll()) {
        localStorage.setItem('live-poll', JSON.stringify({
          liveId: params.id,
          polls: [],
        }))
      }
    }
  } else {
    setIntervalTime(RetryTimeDelayGeneralDataFetch)
    // dispatch(setConfig({...config, get_interval: RetryTimeDelayGeneralDataFetch}));
    setRetryCount(retryCount - 1)
    console.error(`get aggregat error: ${data.detail}`)
  }
}

export const manualGetDataIntervalAPI = async (retryCount: any, intervalIds: any, intervalTime: any, setRetryCount: any, dispatch: any, setIntervalIds: any, setIntervalTime: any, setOnlineViewerIntervalTime: any, setPostDataIntervalTime: any) => {
  const { params } = store.getState().videoData
  const { roomId, chatEnabled, socket, showChat } = store.getState().chats
  const { data, status } = await apiCaller({ url: API().live.generalData })
  if (responseValidator(status) && data.config) {
    if (!!data.backup) window.location.href = (window.location.href.replace(`id=${params.id}`, `id=${data.backup}`).replace(`&t=${params.t}`, ``))
    setRetryCount(RetryCountGeneralDataFetch)
    dispatch(setConfig(data.config))
    if (data.config.get_interval !== intervalTime) {
      await intervalIds.forEach((id: any) => {
        clearInterval(id)
      })
      setIntervalIds([])
      setIntervalTime(data.config.get_interval)
    }
    setOnlineViewerIntervalTime(data.config.viewers_interval)
    setPostDataIntervalTime(data.config.empoji_poll_interval)
    dispatch(setEmojis(data.emojis))
    dispatch(setOnlineViewers(data.online_viewers))
    dispatch(setQuestion(data.question))
    dispatch(setAlternative_Lives(data.alternative_lives))
    dispatch(setMarkers(data.markers.sort(compare)))
    dispatch(setGif(data.gif))
    let roomIdTemp: number | undefined = undefined
  if (data.chat_enabled) {
      let { data: _data, status: _status } = await apiCaller({ url: API().live.liveChat.getRoomId(+String(params.id)) });
      if (responseValidator(_status)) {
        if (roomId !== _data.id && socket) {
          dispatch(setMessages([]));
          dispatch(setChatEnabled(false));
        }
        dispatch(setRoomId(_data.id));
        dispatch(setChatType(_data.type));
        roomIdTemp = _data.id
      }
    } else if (chatEnabled && socket) {
      dispatch(setMessages([]));
      dispatch(setChatEnabled(false));
    }
    
    if (chatEnabled !== !!roomIdTemp) {
      setTimeout(()=> {
        if (showChat) dispatch(setChatPopover(true));
        dispatch(setChatEnabled(!!roomIdTemp));
      }, 0)  
    }

    dispatch(setQuiz(data.quiz))
    if (data.timeline.windows.length) {
      const points: number[] = []
      data.timeline.windows.map((window: { window_number: number, viewers: number }) => points.push(window.viewers))
      dispatch(setChartPoints(points))
    }
    if (!data.question && (data.question && !data.question.active)) {
      // state 1
      if ((!!livePoll() && livePoll().liveId !== params.id) || !livePoll()) {
        localStorage.setItem('live-poll', JSON.stringify({
          liveId: params.id,
          polls: [],
        }))
      }
    }
  } else manualGeneralErrorResponseHandler(retryCount, dispatch, setRetryCount, intervalIds, setIntervalIds, data, 'getData')
}

export const manualPostAPI = async () => {
  const dispatch = store.dispatch
  const { selectedOptionId, emojiList1, emojiList2, params, details } = store.getState().videoData

  if (conditions(ConditionName.manaulPostAPI)) {
    const manualPostData = {
      'poll': {
        'option_id': selectedOptionId,
      },
      'emoji_list_1': emojiList1,
      'emoji_list_2': emojiList2,
      'type': params.type,
      'id': details.id,
      'user_id': params.id,
    }
    const { status } = await postEmojiPoll(manualPostData);
    if (responseValidator(status)) {
      dispatch(setEmojiList1([]))
      dispatch(setEmojiList2([]))
      dispatch(setSelectedOptionId(null))
    }
  }
}

export const manualGetOnlineViewerIntervalAPI = async () => await apiCaller({ url: API().live.online_viewer })

export const handleSubtitle = () => {
  const dispatch = store.dispatch
  const { subtitles, selectedSubtitle } = store.getState().videoData

  const faSubtitle: any = subtitles.find((subtitle: any) => subtitle.language === 'fa')
  if (selectedSubtitle) {
    Object.values(videoTag().textTracks).find((textTrack: any) => textTrack.mode === 'showing')!.mode = 'disabled'
    dispatch(setSubtitleText(''))
    dispatch(setSelectedSubtitle(undefined))
    sendFluentLog(subtitleLog('empty'))
  } else {
    if (faSubtitle) {
      faSubtitle.mode = 'showing'
      dispatch(setSelectedSubtitle(faSubtitle))
      sendFluentLog(subtitleLog(faSubtitle.language))
    } else {
      videoTag().textTracks[0].mode = 'showing'
      dispatch(setSelectedSubtitle(videoTag().textTracks[0]))
      sendFluentLog(subtitleLog(videoTag().textTracks[0].language))
    }
  }
}

export const handleClickRecommendationCard = (event?: any, videoId?: number, userId?: number, videoType?: string, listIndex?: number) => {
  if (event) handleRipple(event, `recommendationList-${videoId}`, 150)
  const { recommendationList } = store.getState().videoData
  handleVideoTimeline(videoTag().currentTime)
  sendFluentLog(recommendationListLog(videoId ?? recommendationList[0].id, userId ?? recommendationList[0].user_id, videoType ?? recommendationList[0].type, listIndex ?? 1))
}

export const combinedMarkers = (personalMarkers: any[], publicMarkers: IMarker[]) => {
    const tempMarker: any[] = [];
    if (personalMarkers) personalMarkers.map((m) => {
        tempMarker.push({
            banner: "",
            id: !!m.id ? m.id : m.time,
            live_id: conditions(ConditionName.isLiveParam) ? m.video_id : 0,
            sticker: m.sticker,
            time: m.time,
            title: m.name,
            video_type: m.video_type,
            video_id: m.video_id,
            description: m.description,
            isPersonal: !!m.id ? m.id : m.time,
        })
    })
    store.dispatch(setMarkers([...publicMarkers, ...tempMarker].sort(compare)))
}

export const handlePlayListTabClick = () => {
  const dispatch = store.dispatch;
  const {playList} = store.getState().videoData;
  dispatch(setPlayListPopover(true));
  sendFluentLog(playListClickLog(playList![0].id));
}

export const handleVideoOfPlaylistClick = (event: MouseEventHandler<HTMLDivElement>, playlistId:number, videoId:number, videoType:number, videoIndex:number) => {
  handleRipple(event, `playList-${videoId}`, 150);
  sendFluentLog(videoOfPlaylistClickLog(playlistId, videoId, videoType, videoIndex))
}

export const handleContentType = () => {
  const { isMovieFilter, isSeriesFilter } = store.getState().tags;
  let contentType: undefined | ContentTypesString.PlayList | ContentTypesString.Vod | `${ContentTypesString.Vod},${ContentTypesString.PlayList}` = undefined;
  if (isMovieFilter && isSeriesFilter) contentType = `${ContentTypesString.Vod},${ContentTypesString.PlayList}`;
  else if (isMovieFilter) contentType = ContentTypesString.Vod;
  else if (isSeriesFilter) contentType = ContentTypesString.PlayList;
  return contentType;
}

export const findFirstVideoInRecommendationList = () => {
  const { recommendationList } = store.getState().videoData;
  const recommendationVideo = recommendationList.find((item:any) => item.type !== "playlist");
  return {
    id: recommendationVideo.id,
    type: recommendationVideo.type,
    banner: recommendationVideo.banner,
    title: recommendationVideo.title
  }
}

export const postEmojiPoll = async (manualPostData:any) => {
  const { status } = await apiCaller({ url: API().live.postData, method: 'POST', data: manualPostData, retryPolicy: [
    {
      codeAbove: null,
      codeBelow: 500,
      excludeCodes: [500,408,407,406,405,404,403,402,401,400],
      includeCodes: [409],
      delay: 3,
      count: 3
    }
  ] })
  return { status }
} 

export const getPlaylistVideos = async(selectedPlaylist:number, offset:number) => {
  const { data, status } = await apiCaller({ url: API().playListVideos(selectedPlaylist), method: 'GET', data: {
      offset: offset,
      limit: 10
  }, retryPolicy: [
      {
        codeAbove: 400,
        codeBelow: null,
        excludeCodes: [],
        includeCodes: [],
        delay: 2,
        count: 3
      }
    ]})
    return { data, status }
}

export const getAllGeneralMarker = async (url:string) => {
  const response:any = await getAll(url, [
      {
          codeAbove: 400,
          codeBelow: null,
          excludeCodes: [],
          includeCodes: [],
          delay: 2,
          count: 3
      }
  ]);
  return response
}

export const getAllPersonalMarkers = async (url:string) => {
  const { data, status } = await apiCaller({
      url: url,
      headers: handleHasXTokenParamOrSendXToken(),
      retryPolicy: [
          {
              codeAbove: 400,
              codeBelow: null,
              excludeCodes: [],
              includeCodes: [],
              delay: 2,
              count: 3
          }
      ]
  });
  return { data, status }
}

export const submitChatComment = async (_data:any) => {
  const { data, status } = await apiCaller({
    url: API().live.liveChat.sendChatMessage,
    method: 'post',
    data: _data,
    headers: handleHasXTokenParamOrSendXToken(),
    retryPolicy: [
      {
        codeAbove: 400,
        codeBelow: null,
        excludeCodes: [],
        includeCodes: [],
        delay: 2,
        count: 3
      }
    ]
  })
  return { data, status }
}

export const getAllChatMessages = async (roomId: number, offset: number) => {
  const { data, status } = await apiCaller({
    url: API().live.liveChat.getMessageList(roomId), method: "GET", data: {
      offset: offset,
      limit: 10,
      ordering: "-created_at"
    },
    retryPolicy: [
      {
        codeAbove: 400,
        codeBelow: null,
        excludeCodes: [],
        includeCodes: [],
        delay: 2,
        count: 3
      }
    ]
  })
  return { data, status }
}

export const getCommentList = async (url:string, offset:number) => {
  const { data, status } = await apiCaller({ url: url, data: {
      limit: 10,
      offset: offset
  },
      retryPolicy: [
          {
              codeAbove: 400,
              codeBelow: null,
              excludeCodes: [],
              includeCodes: [],
              delay: 2,
              count: 3
          }
      ] });
      return { data, status }
}

export const submitComment = async (url:string, _data:any) => {
  const { data, status } = await apiCaller({ url: url, method: "POST", data: _data, headers: handleHasXTokenParamOrSendXToken(), retryPolicy: [
      {
          codeAbove: 400,
          codeBelow: null,
          excludeCodes: [],
          includeCodes: [],
          delay: 2,
          count: 3
      }
  ] });
  return { data, status }
}

export const getPlayListCards = async (url:string) => {
  const { data, status } = await apiCaller({ url: url, retryPolicy: [
      {
          codeAbove: 400,
          codeBelow: null,
          excludeCodes: [],
          includeCodes: [],
          delay: 2,
          count: 3
      }
  ] });
  return { data, status }
}

export const getPlaylistHeader = async (url:string) => {
  const { data, status } = await apiCaller({ url: url, retryPolicy: [
      {
          codeAbove: 400,
          codeBelow: null,
          excludeCodes: [],
          includeCodes: [],
          delay: 2,
          count: 3
      }
  ]});
  return { data, status }
}